module.exports = __webpack_public_path__ + "img/img2.8cd2d17d.png";